'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAppearance = _themer.Themer.createTextDropdownButtonAppearance({
  base: {
    borderRadius: 3
  },
  hover: {},
  focus: {
    boxShadow: '0 0 0 3px ' + _scales2.default.primary.P5A
  },
  active: {},
  disabled: {
    opacity: 0.5
  }
});

/**
 * Get the appearance of a `TextDropdownButton`.
 */
var getTextDropdownButtonAppearance = function getTextDropdownButtonAppearance() {
  return defaultAppearance;
};

/**
 * Get the className of a `TextDropdownButton`.
 */
exports.default = (0, _memoizeClassName2.default)(getTextDropdownButtonAppearance);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvZ2V0VGV4dERyb3Bkb3duQnV0dG9uQ2xhc3NOYW1lLmpzIl0sIm5hbWVzIjpbImRlZmF1bHRBcHBlYXJhbmNlIiwiVGhlbWVyIiwiY3JlYXRlVGV4dERyb3Bkb3duQnV0dG9uQXBwZWFyYW5jZSIsImJhc2UiLCJib3JkZXJSYWRpdXMiLCJob3ZlciIsImZvY3VzIiwiYm94U2hhZG93Iiwic2NhbGVzIiwicHJpbWFyeSIsIlA1QSIsImFjdGl2ZSIsImRpc2FibGVkIiwib3BhY2l0eSIsImdldFRleHREcm9wZG93bkJ1dHRvbkFwcGVhcmFuY2UiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBOztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLG9CQUFvQkMsZUFBT0Msa0NBQVAsQ0FBMEM7QUFDbEVDLFFBQU07QUFDSkMsa0JBQWM7QUFEVixHQUQ0RDtBQUlsRUMsU0FBTyxFQUoyRDtBQUtsRUMsU0FBTztBQUNMQyw4QkFBd0JDLGlCQUFPQyxPQUFQLENBQWVDO0FBRGxDLEdBTDJEO0FBUWxFQyxVQUFRLEVBUjBEO0FBU2xFQyxZQUFVO0FBQ1JDLGFBQVM7QUFERDtBQVR3RCxDQUExQyxDQUExQjs7QUFjQTs7O0FBR0EsSUFBTUMsa0NBQWtDLFNBQWxDQSwrQkFBa0MsR0FBTTtBQUM1QyxTQUFPZCxpQkFBUDtBQUNELENBRkQ7O0FBSUE7OztrQkFHZSxnQ0FBaUJjLCtCQUFqQixDIiwiZmlsZSI6ImdldFRleHREcm9wZG93bkJ1dHRvbkNsYXNzTmFtZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFRoZW1lciB9IGZyb20gJy4uLy4uLy4uLy4uL3RoZW1lcidcbmltcG9ydCBtZW1vaXplQ2xhc3NOYW1lIGZyb20gJy4uL3V0aWxzL21lbW9pemVDbGFzc05hbWUnXG5pbXBvcnQgc2NhbGVzIGZyb20gJy4uL2ZvdW5kYXRpb25hbC1zdHlsZXMvc2NhbGVzJ1xuXG5jb25zdCBkZWZhdWx0QXBwZWFyYW5jZSA9IFRoZW1lci5jcmVhdGVUZXh0RHJvcGRvd25CdXR0b25BcHBlYXJhbmNlKHtcbiAgYmFzZToge1xuICAgIGJvcmRlclJhZGl1czogM1xuICB9LFxuICBob3Zlcjoge30sXG4gIGZvY3VzOiB7XG4gICAgYm94U2hhZG93OiBgMCAwIDAgM3B4ICR7c2NhbGVzLnByaW1hcnkuUDVBfWBcbiAgfSxcbiAgYWN0aXZlOiB7fSxcbiAgZGlzYWJsZWQ6IHtcbiAgICBvcGFjaXR5OiAwLjVcbiAgfVxufSlcblxuLyoqXG4gKiBHZXQgdGhlIGFwcGVhcmFuY2Ugb2YgYSBgVGV4dERyb3Bkb3duQnV0dG9uYC5cbiAqL1xuY29uc3QgZ2V0VGV4dERyb3Bkb3duQnV0dG9uQXBwZWFyYW5jZSA9ICgpID0+IHtcbiAgcmV0dXJuIGRlZmF1bHRBcHBlYXJhbmNlXG59XG5cbi8qKlxuICogR2V0IHRoZSBjbGFzc05hbWUgb2YgYSBgVGV4dERyb3Bkb3duQnV0dG9uYC5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgbWVtb2l6ZUNsYXNzTmFtZShnZXRUZXh0RHJvcGRvd25CdXR0b25BcHBlYXJhbmNlKVxuIl19